import {Injectable} from '@angular/core';
import {RouterService} from '@npck/libs/commons';
import {TableEvent} from '../components/full-table/full-table.component';
import {TrendDetailsTab, TrendDetailsTabState} from '../pages/analytics/trends/details/trend-details.component';
import {Path} from '../path';

@Injectable({providedIn: 'root'})
export class TrendDetailsFilterHolderService {
    private stateByTrend: Record<string, Partial<Record<TrendDetailsTab, TrendDetailsTabState>>> = {};

    constructor(
        private routerService: RouterService,
    ) {
        this.routerService.navigationEnd()
            .subscribe(event => {
                if (!event.url.includes(Path.ANALYTICS)) {
                    this.clear();
                }
            });
    }

    getState(trendId: string, tab: TrendDetailsTab): TrendDetailsTabState | undefined {
        return this.stateByTrend[trendId]?.[tab];
    }

    storeTableState(trendId: string, tab: TrendDetailsTab, tableEvent: TableEvent): TrendDetailsTabState {
        this.stateByTrend[trendId] = this.stateByTrend[trendId] ?? {};
        const newState: TrendDetailsTabState = {
            tableEvent: {...tableEvent, filter: {...tableEvent.filter}},
        };
        this.stateByTrend[trendId][tab] = newState;
        return newState;
    }

    clear(): void {
        this.stateByTrend = {};
    }
}
